import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import ContactRms from './contact-rms';
import ContactRmsDetail from './contact-rms-detail';
import ContactRmsUpdate from './contact-rms-update';
import ContactRmsDeleteDialog from './contact-rms-delete-dialog';

const ContactRmsRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<ContactRms />} />
    <Route path="new" element={<ContactRmsUpdate />} />
    <Route path=":id">
      <Route index element={<ContactRmsDetail />} />
      <Route path="edit" element={<ContactRmsUpdate />} />
      <Route path="delete" element={<ContactRmsDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default ContactRmsRoutes;
